import { setSelectedVaultAddress } from '@/features/vault/slice';
import { RouteBasePath } from '@/types/routers';

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '..';
export const getVaultLink = () => {
  return `/${RouteBasePath.launchpad}`;
};
export default function useVaultRouter() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const goToVault = useCallback(
    ({ vaultAddress }: { vaultAddress?: string }) => {
      dispatch(setSelectedVaultAddress(vaultAddress || null));
    },
    [navigate, dispatch],
  );

  return { goToVault, getVaultLink };
}
